import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

export function ProtectedRoute({ permission, permissions, children, fallback }) {
  const { hasPermission, hasAnyPermission, loading } = usePermissions();

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;
  }

  const hasAccess = permission 
    ? hasPermission(permission)
    : permissions 
      ? hasAnyPermission(...permissions)
      : true;

  if (!hasAccess) {
    return fallback || (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h2 style={{ color: '#dc2626' }}>Access Denied</h2>
        <p style={{ color: '#6b7280' }}>You don't have permission to view this page.</p>
      </div>
    );
  }

  return children;
}

export function PermissionGate({ permission, permissions, children }) {
  const { hasPermission, hasAnyPermission, loading } = usePermissions();

  if (loading) return null;

  const hasAccess = permission 
    ? hasPermission(permission)
    : permissions 
      ? hasAnyPermission(...permissions)
      : true;

  return hasAccess ? children : null;
}

export default ProtectedRoute;
